function onlyUnique<T>(value: T, index: number, self: Array<T>) {
  return self.indexOf(value) === index;
}

export function distinct<T>(array: Array<T>) {
  return array.filter(onlyUnique);
}
